import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useMapIsFavorite, addMapFavorite, removeMapFavorite } from '../slices/map'
import {
  ADD_TO_FAVORITE,
  REMOVE_FROM_FAVORITE
} from '../trans'

const FavoriteControl = (props) => {

  const {feature, className} = props
  const dispatch = useDispatch() 
  const isFavorite = useMapIsFavorite(feature)

  const onClickHandler = (e) =>  {
    if (isFavorite) {
      dispatch(removeMapFavorite(feature))
    } else {
      dispatch(addMapFavorite(feature))
    }
  }

  return (
    <button onClick={onClickHandler} className={className}> { isFavorite ? REMOVE_FROM_FAVORITE : ADD_TO_FAVORITE } </button> 
  )

}

export default FavoriteControl
